// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили карточек */
.Vacancies_card__-oX\\+g {
  padding: 16px;
  margin-bottom: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.Vacancies_container__tq5q1 {
  padding: 20px;
}

.Vacancies_controls__D-oz8 {
   display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.Vacancies_card__-oX\\+g:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* Стили для списка */
.Vacancies_listView__wj\\+FT {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  overflow: hidden;
}

.Vacancies_listHeader__YyeaZ {
  display: grid;
  grid-template-columns: 80px 2fr 120px 120px 120px;
  gap: 16px;
  padding: 12px 16px;
  background: #fafafa;
  font-weight: 500;
  border-bottom: 1px solid #f0f0f0;
}

/* Стили для канбан-доски */
/* Kanban View */
.Vacancies_kanbanView__YTFAt {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.Vacancies_kanbanColumn__fmBWG {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
}

.Vacancies_kanbanColumn__fmBWG h3 {
  margin-top: 0;
  text-align: center;
}

.Vacancies_kanbanCards__ofepI {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 15px;
}

.Vacancies_kanbanCard__E6OJ8 {
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: white;
}

.Vacancies_kanbanCardContent__W1uyF {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Vacancies_kanbanCardMeta__qMShR {
  display: flex;
  justify-content: space-between;
  font-size: 0.8em;
  color: #666;
}
.Vacancies_kanbanColumnHeader__vb225 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
}

.Vacancies_countBadge__re2c6 {
  background: #6c757d;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8em;
}

.Vacancies_kanbanActions__KWF4c {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 10px;
}

.Vacancies_kanbanActions__KWF4c button {
  width: 100%;
  padding: 5px;
  font-size: 0.8em;
}

/* Стили для действий */
.Vacancies_actions__Ma6tG {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.Vacancies_actions__Ma6tG button {
  padding: 4px 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.Vacancies_actions__Ma6tG button:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.Vacancies_kanbanActions__KWF4c {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 12px;
}

.Vacancies_kanbanActions__KWF4c button {
  width: 100%;
  padding: 4px;
  font-size: 12px;
  text-align: left;
  background: #f5f5f5;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.Vacancies_kanbanActions__KWF4c button:hover {
  background: #e6f7ff;
  color: #1890ff;
}

/* Стили для статусов */
.Vacancies_statusTag__Bzh3o {
  margin-left: 8px;
  font-size: 12px;
}

.Vacancies_viewToggle__cTEv9 {
  display: flex;
  gap: 10px;
}

.Vacancies_viewToggle__cTEv9 button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
}

.Vacancies_viewToggle__cTEv9 button.Vacancies_active__EZrUs {
  background: #007bff;
  color: white;
}

/* Адаптивные стили */
@media (max-width: 1200px) {
  .Vacancies_kanbanView__YTFAt {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .Vacancies_listHeader__YyeaZ {
    grid-template-columns: 60px 1fr 100px;
  }

  .Vacancies_listHeader__YyeaZ div:nth-child(4),
  .Vacancies_listHeader__YyeaZ div:nth-child(5) {
    display: none;
  }

  .Vacancies_kanbanView__YTFAt {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Vacancies/Vacancies.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;;AAEA;GACG,aAAa;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,2BAA2B;AAC3B,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Общие стили карточек */\n.card {\n  padding: 16px;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n.container {\n  padding: 20px;\n}\n\n.controls {\n   display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transform: translateY(-2px);\n}\n\n/* Стили для списка */\n.listView {\n  border: 1px solid #f0f0f0;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.listHeader {\n  display: grid;\n  grid-template-columns: 80px 2fr 120px 120px 120px;\n  gap: 16px;\n  padding: 12px 16px;\n  background: #fafafa;\n  font-weight: 500;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n/* Стили для канбан-доски */\n/* Kanban View */\n.kanbanView {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 20px;\n}\n\n.kanbanColumn {\n  background: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n}\n\n.kanbanColumn h3 {\n  margin-top: 0;\n  text-align: center;\n}\n\n.kanbanCards {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.kanbanCard {\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background: white;\n}\n\n.kanbanCardContent {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.kanbanCardMeta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.8em;\n  color: #666;\n}\n.kanbanColumnHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.countBadge {\n  background: #6c757d;\n  color: white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8em;\n}\n\n.kanbanActions {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-top: 10px;\n}\n\n.kanbanActions button {\n  width: 100%;\n  padding: 5px;\n  font-size: 0.8em;\n}\n\n/* Стили для действий */\n.actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.actions button {\n  padding: 4px 8px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  background: #fff;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.actions button:hover {\n  border-color: #1890ff;\n  color: #1890ff;\n}\n\n.kanbanActions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.kanbanActions button {\n  width: 100%;\n  padding: 4px;\n  font-size: 12px;\n  text-align: left;\n  background: #f5f5f5;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.kanbanActions button:hover {\n  background: #e6f7ff;\n  color: #1890ff;\n}\n\n/* Стили для статусов */\n.statusTag {\n  margin-left: 8px;\n  font-size: 12px;\n}\n\n.viewToggle {\n  display: flex;\n  gap: 10px;\n}\n\n.viewToggle button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  background: #fff;\n  cursor: pointer;\n}\n\n.viewToggle button.active {\n  background: #007bff;\n  color: white;\n}\n\n/* Адаптивные стили */\n@media (max-width: 1200px) {\n  .kanbanView {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .listHeader {\n    grid-template-columns: 60px 1fr 100px;\n  }\n\n  .listHeader div:nth-child(4),\n  .listHeader div:nth-child(5) {\n    display: none;\n  }\n\n  .kanbanView {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Vacancies_card__-oX+g`,
	"container": `Vacancies_container__tq5q1`,
	"controls": `Vacancies_controls__D-oz8`,
	"listView": `Vacancies_listView__wj+FT`,
	"listHeader": `Vacancies_listHeader__YyeaZ`,
	"kanbanView": `Vacancies_kanbanView__YTFAt`,
	"kanbanColumn": `Vacancies_kanbanColumn__fmBWG`,
	"kanbanCards": `Vacancies_kanbanCards__ofepI`,
	"kanbanCard": `Vacancies_kanbanCard__E6OJ8`,
	"kanbanCardContent": `Vacancies_kanbanCardContent__W1uyF`,
	"kanbanCardMeta": `Vacancies_kanbanCardMeta__qMShR`,
	"kanbanColumnHeader": `Vacancies_kanbanColumnHeader__vb225`,
	"countBadge": `Vacancies_countBadge__re2c6`,
	"kanbanActions": `Vacancies_kanbanActions__KWF4c`,
	"actions": `Vacancies_actions__Ma6tG`,
	"statusTag": `Vacancies_statusTag__Bzh3o`,
	"viewToggle": `Vacancies_viewToggle__cTEv9`,
	"active": `Vacancies_active__EZrUs`
};
export default ___CSS_LOADER_EXPORT___;
